import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryTermDefinitionText({definition, search, highlight}) {
    // Used in

    // BUILD
    if (isNullOrUndefined(definition))
        return null
    return (
        <div className={"text-[14px] font-normal min-w-0 text-greyLight9"}
             dangerouslySetInnerHTML={{ __html: highlight(definition, search) }} />
    );
}